import { render, staticRenderFns } from "./PhaseTypeReviewEditServiceInterface.vue?vue&type=template&id=5389d6cc&scoped=true"
import script from "./PhaseTypeReviewEditServiceInterface.vue?vue&type=script&lang=js"
export * from "./PhaseTypeReviewEditServiceInterface.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeReviewEditServiceInterface.vue?vue&type=style&index=0&id=5389d6cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389d6cc",
  null
  
)

export default component.exports